import { Link } from "react-router-dom";

const logoSrc = "/logo.png";

export default function FooterSection() {
  return (
    <footer className="bg-[#050505] border-t border-white/5">
      {/* CTA Block */}
      <div className="py-24 border-b border-white/5">
        <div className="max-w-[1200px] mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">准备好探索了吗？</h2>
          <p className="text-sm text-white/40 mb-8">从想法到突破，AI 陪你走完最后一公里</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#3d69e8] hover:bg-[#3060d0] text-white text-sm font-medium px-6 py-3 rounded-lg transition-colors cursor-pointer no-underline whitespace-nowrap"
            >
              <i className="ri-play-circle-line"></i>
              免费开始使用
            </Link>
            <a
              href="#features"
              className="inline-flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-white text-sm font-medium px-6 py-3 rounded-lg transition-colors cursor-pointer no-underline whitespace-nowrap"
            >
              查看完整功能
            </a>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="py-8">
        <div className="max-w-[1200px] mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <img src={logoSrc} alt="ScienceOne" className="h-6 w-6 rounded-full object-cover flex-shrink-0" />
            <span className="font-bold text-white text-base">ScienceOne</span>
          </div>
          <div className="flex items-center gap-6 flex-wrap justify-center">
            <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors cursor-pointer no-underline whitespace-nowrap">关于我们</a>
            <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors cursor-pointer no-underline whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors cursor-pointer no-underline whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors cursor-pointer no-underline whitespace-nowrap">联系我们</a>
          </div>
          <div className="text-xs text-white/20">© 2025 ScienceOne. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
